up.compiler('script[type="up-disabled-script"]', function(element) {
  if (element.src?.startsWith('https://www.recaptcha.net')) {
    const clone = up.element.createFromHTML(element.outerHTML)
    clone.type = 'text/javascript'
    clone.nonce = document.querySelector('meta[name="csp-nonce"]')?.content
    element.replaceWith(clone)
  }
})
